export default __webpack_public_path__ + "static/media/delete.e6fa909f.svg";